import { Flex, Text } from '@chakra-ui/react';

import { SignUpSectionProps } from './types';

function SignUpSection({ title, children }: SignUpSectionProps) {
  return (
    <Flex flexDir="column" gap="10px">
      <Text
        bgColor="brand.purpleAlpha10"
        borderRadius="3px"
        color="brand.darkPurple"
        textStyle="smallMedium"
        px="10px"
        py="5px"
      >
        {title}
      </Text>
      <Flex flexDir="column" gap="20px">
        {children}
      </Flex>
    </Flex>
  );
}

export default SignUpSection;
